import { HttpService } from './https.service';
import { BASE_URL } from '../../config/config';

const http = new HttpService();

export class InfluencerProfileService {
  async getInfluencerProfile(data: {
    sm_id: number | string;
    user_id: number | string;
    account_id: number | string;
    brand_id: number | string;
    influencer_id: number | string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/influencer/profile-insight?sm_id=${data.sm_id}&user_id=${data.user_id}&account_id=${data.account_id}&brand_id=${data.brand_id}&influencer_id=${data.influencer_id};`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer Profile page :: ${error}`);
    }
  }

  async getBrandProfile(data: {
    sm_id: number | string;
    user_id: number | string;
    account_id: number | string;
    brand_id: number | string;
    influencer_id: number | string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/brand/profile-insight?sm_id=${data.sm_id}&user_id=${data.user_id}&account_id=${data.account_id}&brand_id=${data.brand_id}&influencer_id=${data.influencer_id}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer Profile page :: ${error}`);
    }
  }

  async getInfluencerProfileYt(data: {
    sm_id: number | string;
    user_id: number | string;
    account_id: number | string;
    brand_id: number | string;
    influencer_id: number | string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/influencer/profile-insight-yt?sm_id=${data.sm_id}&user_id=${data.user_id}&account_id=${data.account_id}&brand_id=${data.brand_id}&influencer_id=${data.influencer_id};`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer YouTube Profile Page :: ${error}`);
    }
  }

  // Sets auth_influencer_ig.on_request_update = True for the influencer's IG
  // account, flagging their profile for a manual data refresh. Once set, the
  // "Update profile" button on profile-insight stays disabled until the
  // backend clears the flag after processing the update.
  async requestProfileUpdate(data: {
    sm_id: number | string;
    platform: string;
    user_id: number | string;
    account_id: number | string;
    brand_id: number | string;
    influencer_id: number | string;
  }): Promise<any> {
    const path = BASE_URL + `/brand/profile-insight/request-update`;
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Request Profile Update :: ${error}`);
    }
  }

  async getBrandProfileYt(data: {
    sm_id: number | string;
    user_id: number | string;
    account_id: number | string;
    brand_id: number | string;
    influencer_id: number | string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/brand/profile-insight-yt?sm_id=${data.sm_id}&user_id=${data.user_id}&account_id=${data.account_id}&brand_id=${data.brand_id}&influencer_id=${data.influencer_id}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer YouTube Profile Page :: ${error}`);
    }
  }
  async getBrandProfileFB(data: { url_id: any }): Promise<any> {
    const path = BASE_URL + `/brand/profile-insight-fb?url_id=${data.url_id}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Brand Facebook Profile Page :: ${error}`);
    }
  }

  // ---------------------------------------------------------------------------
  // Share profile-insight (public link) — mirrors the campaign analytics share
  // flow (analytics.service.ts: analyticsSharePublicLink / verifySharedUser /
  // shareBrandAnalytics). The access key is a self-contained JWT encoding
  // { sm_id, influencer_id } so NO db changes are required.
  // ---------------------------------------------------------------------------

  // Generates (or returns existing) public share URL for a profile.
  async profileInsightSharePublicLink(data: {
    sm_id: number | string;
    influencer_id: number | string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/get/profile-insight/share-link?sm_id=${data.sm_id}&influencer_id=${data.influencer_id}`;
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      console.error("Error in profileInsightSharePublicLink:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`profileInsightSharePublicLink :: ${error}`);
    }
  }

  // Verifies the access key (JWT) from the shared URL and returns { sm_id, influencer_id }.
  async verifySharedProfileInsight(data: { accessKey: string | null }): Promise<any> {
    const path =
      BASE_URL + `/profile-insight/share/verify-token?accessKey=${data.accessKey}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in verifySharedProfileInsight:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`verifySharedProfileInsight :: ${error}`);
    }
  }

  // Fetches the profile-insight data for the shared (public) view.
  async getSharedProfileInsight(data: {
    sm_id: number | string;
    influencer_id: number | string;
    accessKey: string | null;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/get/share-profile-insight?sm_id=${data.sm_id}&influencer_id=${data.influencer_id}&accessKey=${data.accessKey}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in getSharedProfileInsight:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`getSharedProfileInsight :: ${error}`);
    }
  }

  // ---------------------------------------------------------------------------
  // Share YouTube profile-insight (public link) — same flow as the IG share
  // methods above. Stateless JWT encoding { sm_id, influencer_id }.
  // ---------------------------------------------------------------------------

  async profileInsightYtSharePublicLink(data: {
    sm_id: number | string;
    influencer_id: number | string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/get/profile-insight-yt/share-link?sm_id=${data.sm_id}&influencer_id=${data.influencer_id}`;
    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      console.error("Error in profileInsightYtSharePublicLink:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`profileInsightYtSharePublicLink :: ${error}`);
    }
  }

  async verifySharedProfileInsightYt(data: { accessKey: string | null }): Promise<any> {
    const path =
      BASE_URL + `/profile-insight-yt/share/verify-token?accessKey=${data.accessKey}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in verifySharedProfileInsightYt:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`verifySharedProfileInsightYt :: ${error}`);
    }
  }

  async getSharedProfileInsightYt(data: {
    sm_id: number | string;
    influencer_id: number | string;
    accessKey: string | null;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/get/share-profile-insight-yt?sm_id=${data.sm_id}&influencer_id=${data.influencer_id}&accessKey=${data.accessKey}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      console.error("Error in getSharedProfileInsightYt:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
      throw new Error(`getSharedProfileInsightYt :: ${error}`);
    }
  }

  async activeAudienceHealth(payload: any) {
      const path = `${BASE_URL}/brand/active-audience-health`;
      try {
        const response = await http.postRequest(path, payload, null);
        return response;
      } catch (error) {
        console.error("Error in activeAudienceHealth:", JSON.stringify(error, Object.getOwnPropertyNames(error)));
        throw new Error(`activeAudienceHealth :: ${error}`);
      }
    }

  // async getProfilePostYt(data: { sm_id: number, influencer_id: number | string, filter_value: number | string, filter_unit: string }): Promise<any> {
  //   const path = BASE_URL + `/profile-insight-yt/post?sm_id=${data.sm_id}&influencer_id=${data.influencer_id}&filter_value=${data.filter_value}&filter_unit=${data.filter_unit}`;
  //   try {
  //     const response = await http.getRequest(path, null);
  //     return response;
  //   } catch (error) {
  //     throw new Error(`Influencer YouTube Profile Page :: ${error}`);
  //   }
  // }

  async getProfilePostYt(data: {
    sm_id: number;
    influencer_id: number | string;
    filter_value: number | string;
    filter_unit: string;
    type: "videos" | "shorts";
    filter_type: "recent" | "organic" | "paid" | "top";
    page?: number;
    limit?: number;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/profile-insight-yt/post` +
      `?sm_id=${data.sm_id}` +
      `&influencer_id=${data.influencer_id}` +
      `&filter_value=${data.filter_value}` +
      `&filter_unit=${data.filter_unit}` +
      `&type=${data.type}` +
      `&filter_type=${data.filter_type}` +
      `&page=${data.page ?? 1}` +
      `&limit=${data.limit ?? 10}`;

    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer YouTube Profile Page :: ${error}`);
    }
  }

  async getProfileEngagementYt(data: {
    sm_id: number;
    influencer_id: number | string;
    filter_value: number | string;
    filter_unit: string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/profile-insight-yt/engagement?sm_id=${data.sm_id}&influencer_id=${data.influencer_id}&filter_value=${data.filter_value}&filter_unit=${data.filter_unit}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer YouTube Profile Page :: ${error}`);
    }
  }

  async getProfileCommentsYt(data: {
    sm_id: number;
    influencer_id: number | string;
  }): Promise<any> {
    const path =
      BASE_URL +
      `/profile-insight-yt/comments?sm_id=${data.sm_id}&influencer_id=${data.influencer_id}`;
    try {
      const response = await http.getRequest(path, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer YouTube Profile Page :: ${error}`);
    }
  }
  async getIGProfileAIData(data: {
    sm_id?: number;
    influencer_id?: number | string;
    user_query: string;
    user_id: number;
    brand_id: number;
    account_id: number;
    influencerData:any
  
  }): Promise<any> {
    const path = `${BASE_URL}/brand/ai/chat`;

    try {
      const response = await http.postRequest(path, data, null);
      return response;
    } catch (error) {
      throw new Error(`Influencer AI Chat :: ${error}`);
    }
  }
}
